/**
 * DevExtreme (esm/__internal/grids/grid_core/keyboard_navigation/scrollable_a11y.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import $ from "../../../../core/renderer";
import {
    isDefined,
    isEmptyObject
} from "../../../../core/utils/type";
export var keyboardNavigationScrollableA11yExtender = Base => class extends Base {
    rowsViewFocusHandler(event) {
        var $target = $(event.target);
        this.translateFocusIfNeed(event, $target);
        super.rowsViewFocusHandler(event)
    }
    rowsViewFocusOutHandler() {
        super.rowsViewFocusOutHandler();
        this.makeScrollableFocusableIfNeed()
    }
    translateFocusIfNeed(event, $target) {
        var needTranslateFocus = this.isScrollableNeedFocusable();
        var isFirstCellFixed = this._isFixedColumn(0);
        if (!needTranslateFocus || !isFirstCellFixed) {
            return
        }
        var $firstCell = this._rowsView.getCell({
            rowIndex: 0,
            columnIndex: 0
        });
        var firstCellHasTabIndex = !!$firstCell.attr("tabindex");
        var notFixedCellIsTarget = $target.is(this._$firstNotFixedCell);
        if (firstCellHasTabIndex && notFixedCellIsTarget) {
            event.preventDefault();
            this._focus($firstCell)
        }
    }
    renderCompleted(e) {
        this._$firstNotFixedCell = this.getFirstNotFixedCell();
        this.makeScrollableFocusableIfNeed();
        super.renderCompleted(e)
    }
    _focus($cell, disableFocus, skipFocusEvent) {
        super._focus($cell, disableFocus, skipFocusEvent);
        this.makeScrollableFocusableIfNeed()
    }
    _tabKeyHandler(eventArgs, isEditing) {
        var _a;
        var isCellPositionDefined = isDefined(this._focusedCellPosition) && !isEmptyObject(this._focusedCellPosition);
        var isOriginalHandlerRequired = !isCellPositionDefined || !eventArgs.shift && this._isLastValidCell(this._focusedCellPosition) || eventArgs.shift && this._isFirstValidCell(this._focusedCellPosition);
        var isNeedFocusable = this.isScrollableNeedFocusable();
        if (isOriginalHandlerRequired && isNeedFocusable) {
            null === (_a = this._$firstNotFixedCell) || void 0 === _a ? void 0 : _a.removeAttr("tabIndex")
        }
        super._tabKeyHandler(eventArgs, isEditing)
    }
    getFirstNotFixedCell() {
        var _a;
        var columns = this._columnsController.getVisibleColumns();
        var columnIndex = columns.findIndex(_ref => {
            var {
                fixed: fixed
            } = _ref;
            return !fixed
        });
        var isEditing = null === (_a = this._editingController) || void 0 === _a ? void 0 : _a.isEditing();
        return -1 === columnIndex || isEditing ? void 0 : this._rowsView._getCellElement(0, columnIndex)
    }
    isScrollableNeedFocusable() {
        var _a, _b;
        var hasScrollable = !!this._rowsView.getScrollable();
        var hasFixedTable = !!(null === (_a = this._rowsView._fixedTableElement) || void 0 === _a ? void 0 : _a.length);
        var isCellsRendered = !!(null === (_b = this._rowsView.getCellElements(0)) || void 0 === _b ? void 0 : _b.length);
        return hasScrollable && hasFixedTable && isCellsRendered
    }
    makeScrollableFocusableIfNeed() {
        var needFocusable = this.isScrollableNeedFocusable();
        if (!needFocusable || !this._$firstNotFixedCell) {
            return
        }
        this._applyTabIndexToElement(this._$firstNotFixedCell)
    }
};
